module.exports = __webpack_public_path__ + "media/images/ln/constellation_12-53c38617ef89fafb9b9499f6afea9829.png";